import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { SaleOrderItemsInfo } from './sale-order-items-info.model';
import { SoInvoiceDetailsInfo } from './so-invoice-details.model';
import { SalePoDetailsInfo } from './so-po-details.model';
import { SaleStatusEnum, SoProcessTypesEnum, SoTypesEnum } from '@gtpl/shared-models/common-models';
export class SaleOrderDto {
    @ApiProperty()
    filePath: string;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderNumber: string;
    @ApiProperty()
    InspectionId: number;
    @ApiProperty()
    status: string;

    @ApiProperty({enum:Object.values(SoProcessTypesEnum)})
  @IsNotEmpty()
  @IsEnum(SoProcessTypesEnum)
  soProcessType: SoProcessTypesEnum; 

  @ApiProperty({enum:Object.values(SoTypesEnum)})
  @IsNotEmpty()
  @IsEnum(SoTypesEnum)
  soType: SoTypesEnum; 

    // @ApiProperty()
    // soProcessType: SoProcessTypesEnum;

    @ApiProperty()
    currencyId: number;

    @ApiProperty()
    snspectionId: any;

    @ApiProperty()
    factoryId: number;

    @ApiProperty({ type: [SaleOrderItemsInfo]})
    saleOrderItemsInfo: SaleOrderItemsInfo[];
    @ApiProperty()
    soInvDetailsInfo: SoInvoiceDetailsInfo;
    @ApiProperty()
    soPoDetailsInfo: SalePoDetailsInfo;

    @ApiProperty()
    operation?: string;


    @ApiProperty()
    isActive: boolean;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
    createdUser : string;

    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;

    @ApiProperty()
    versionFlag : number;
    @ApiProperty()
    isUpdate:boolean
    @ApiProperty()
    subJobCodeListData? : any;

}

export class SoViewRequestDto{
    @ApiProperty()
    selectedSaleOrder:string;
    @ApiProperty()
    selectedCustomer:number;
    @ApiProperty()
    selectedEndCustomer:number;
    @ApiProperty()
    selectedStatus:number;
    @ApiProperty()
    selectedExpectedDate:number;
  }

